/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { ReservationSearchState } from '../state/ReservationSearchState'
import ReservationEvent from '../../event/ReservationEvent'
import UserEvent from '../../event/UserEvent'

class ReservationSearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReservationSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.onEditSearchCondition:
        return state.set(payload.name, payload.value)

      case UserEvent.fetchUserHotels:
        const options = payload.hotels.map(hotel => ({ value: hotel.id, label: hotel.name }))
        return state.merge({
          search_hotel_options: options
        })

      default:
        return state
    }
  }
}

export default new ReservationSearchStore()
